import { useFormContext, useWatch } from 'react-hook-form';
import InvoiceRenderer from './InvoiceRenderer';
import { BillCreateFormData } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';

const InvoiceRendererContainer = () => {
  const { control } = useFormContext<BillCreateFormData>();

  const values = useWatch<BillCreateFormData>({ control });

  return <InvoiceRenderer values={values as BillCreateFormData} />;
};

export default InvoiceRendererContainer;
